import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";
import { Role } from "@/types/roles";
import qs from "qs";

type OnlinePractitioners = {
  providers: {
    displayNameInternal: string;
    photo: string;
    userId: string;
  }[];
};

export const useOnlinePractitioners = () => {
  return useApi<OnlinePractitioners>({
    queryOptions: {
      queryKey: QueryKeys.Provider.ONLINE_PRACTITIONERS,
      queryFn: async () => {
        const response = await axiosInstance.get("/providers/get-online", {
          params: {
            roles: [Role.MD, Role.NP],
          },
          paramsSerializer: (params) => {
            return qs.stringify(params, { arrayFormat: "repeat" });
          },
        });
        return response.data;
      },
      staleTime: 30000,
    },
  });
};
